/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../../helpers'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../app/redux/store'
import SidebarSubItem from './SidebarSubItem'

type Props = {

}

const SidebarMenuMain: React.FC<Props> = () => {

  interface UserModule {
    name: string;
    read: boolean;
    // Add other properties as needed
  }

  // Assuming userSlice.access.modules is of type UserModule[]

  const userSlice = useSelector((state: RootState) => state.user)
  const userModules: UserModule[] = userSlice.profile.modules;

  const envCheck = process.env.REACT_APP_QC_MODE

  const getAccessModule = (title: string) => {
    const accessModule = userModules.some((module) => module.name === title && module.read);
    return accessModule
  }

  const accessObject = {
    unit: getAccessModule('Unit'),
    room: getAccessModule('Room'),
    maintenance: getAccessModule('Maintenance'),
    tenantData: getAccessModule('Tenant Data'),
    etenancies: getAccessModule('E-Tenancies'),
    activeTenant: getAccessModule('Active Tenant'),
    landlordData: getAccessModule('Landlord Data'),
    activeLandlord: getAccessModule('Active Landlord'),
    managementAgreement: getAccessModule('Management Agreement'),
    operatorData: getAccessModule('Operator Data'),
    activeOperator: getAccessModule('Active Operator'),
    ownerData: getAccessModule('Owner Data'),
    ownerPayment: getAccessModule('Owner Payment'),
    ownerSubscription: getAccessModule('Owner Subscription'),
    myOwnerSubscription: getAccessModule('My Subscription'),
    myOwnerBill: getAccessModule('My Owner Bill'),
    store: getAccessModule('Store'),
    PurchaseHistory: getAccessModule('PurchaseHistory'),
    smartMeter: getAccessModule('Smart Meter'),
    smartDoorLocks: getAccessModule('Smart Door Locks'),
    smartLockGateway: getAccessModule('Smart Lock Gateway'),
    billing: getAccessModule('Billing'),
    depositRefund: getAccessModule('Deposit Refund'),
    receipt: getAccessModule('Receipts'),
    expenses: getAccessModule('Expenses'),
    paymentVoucher: getAccessModule('Payment Voucher'),
    // tenantDashboard: getAccessModule('Tenant Dashboard'),
    // dashboard: getAccessModule('Dashboard'),
    inventoryList: getAccessModule('Inventory List'),
    inventoryTransaction: getAccessModule('Inventory Transaction'),
    payoutReport: getAccessModule('Management Property Payout Report'),
    userRole: getAccessModule('User Role'),
    administratorProfile: getAccessModule('Administrator Profile'),
    auditTrails: getAccessModule('Audit Trails'),
    paymentTransaction: getAccessModule('Payment Transaction'),
    payoutTransaction: getAccessModule('Payout Transaction'),
    officeData: getAccessModule('Office Account Data'),
    billType: getAccessModule('Bill Type'),
    expensesType: getAccessModule('Expenses Type'),
    contractorData: getAccessModule('Contractor Data'),
    settings: getAccessModule('Settings'),
    announcement: getAccessModule('Announcement Management'),
    nextsixListing: getAccessModule('Nextsix Listing'),
    showcaseListing: getAccessModule('Showcase Listing'),
    eInvoiceSetUp: getAccessModule('E-Invoice Form Set Up'),
    creditNote: getAccessModule('Credit Note'),
    debitNote: getAccessModule('Debit Note'),
    ownerBill: getAccessModule('Invoice')
  }

  return (
    <>
      {userSlice?.role === 'Tenant' ?
        <>
          {/* Tenant Dashboard */}
          <SidebarMenuItem
            to='/tenant-dashboard'
            title='Dashboard'
            path='dashboard'
          />
        </> :
        <>
          {/* Dashboard */}
          <SidebarMenuItem
            to='dashboard'
            title='Dashboard'
            path='dashboard'
          />
        </>
      }

      {/* Property */}
      <SidebarSubItem
        to='property'
        title='Property'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.unit &&
          <SidebarMenuItem
            to='property/unit'
            title='Unit'
            path='propertyunit'
          />
        }
        {accessObject.room &&
          <SidebarMenuItem
            to='property/room'
            title='Room'
            path='propertyroom'
          />
        }
        {accessObject.maintenance &&
          <SidebarMenuItem
            to='property/maintenance'
            title='Maintenance'
            path='maintenance'
          />
        }
      </SidebarSubItem>

      {/* Tenant */}
      <SidebarSubItem
        to='tenant'
        title='Tenant'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.tenantData &&
          <SidebarMenuItem
            to='tenant/data'
            title='Tenant Data'
            path='tenant'
          />
        }
        {accessObject.etenancies &&
          <SidebarMenuItem
            to='tenant/e-tenancies'
            title='E-Tenancies'
            path='etenancies'
          />
        }
        {accessObject.activeTenant &&
          <SidebarMenuItem
            to='tenant/active'
            title='Active Tenant'
            path='activetenant'
          />
        }
      </SidebarSubItem>

      {/* Landlord */}
      <SidebarSubItem
        to='landlord'
        title='Landlord'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.landlordData &&
          <SidebarMenuItem
            to='landlord/data'
            title='Landlord Data'
            path='landlorddata'
          />
        }
        {accessObject.activeLandlord &&
          <SidebarMenuItem
            to='landlord/active'
            title='Active Landlord'
            path='activelandlord'
          />
        }
        {accessObject.managementAgreement &&
          <SidebarMenuItem
            to='landlord/agreement'
            title='Management Agreement'
            path='managementagreement'
          />
        }
      </SidebarSubItem>

      {/* Operator */}
      <SidebarSubItem
        to='operator'
        title='Operator'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.operatorData &&
          <SidebarMenuItem
            to='operator/data'
            title='Operator Data'
            path='operatordata'
          />
        }
        {accessObject.activeOperator &&
          <SidebarMenuItem
            to='operator/active'
            title='Active Operator'
            path='activeoperator'
          />
        }
      </SidebarSubItem>

      {/* Owner */}
      <SidebarSubItem
        to='owner'
        title='Owner'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.ownerData &&
          <SidebarMenuItem
            to='owner/data'
            title='Owner Data'
            path='ownerdata'
          />
        }
        {/* {accessObject.ownerPayment && // access module was archived
          <SidebarMenuItem
            to='owner/payment'
            title='Owner Payment'
            path='ownerPayment'
          />
        } */}
        {accessObject.ownerSubscription &&
          <SidebarMenuItem
            to='owner/subscription'
            title='Owner Subscription'
            path='ownerSubscription'
          />
        }
      </SidebarSubItem>

      {/* Owner's subscription */}
      {userSlice?.role === 'Owner' &&
        <SidebarSubItem
          to='owner'
          title='Subscription'
          fontIcon='bi-archive'
          icon='element-plus'
        >
          {accessObject.myOwnerSubscription &&
            <SidebarMenuItem
              to='owner/my-subscription'
              title='My Subscription'
              path='myOwnerSubscription'
            />}
          {accessObject.myOwnerBill &&
            <SidebarMenuItem
              to='owner/my-invoice'
              title='My Invoice'
              path='myOwnerBill'
            />}
        </SidebarSubItem>
      }

      {/* Service Cart */}
      {userSlice?.role === 'Owner' &&
        <SidebarSubItem
          to='service-cart'
          title='Service Cart'
          fontIcon='bi-archive'
          icon='element-plus'
        >
          {accessObject.store &&
            <SidebarMenuItem
              to='service-cart/store'
              title='Store'
              path='store'
            />
          }
          {accessObject.PurchaseHistory &&
            <SidebarMenuItem
              to='service-cart/purchase-history'
              title='Purchase History'
              path='purchase-history'
            />
          }
        </SidebarSubItem>}

      {/* Office  */}
      <SidebarSubItem
        to='office'
        title='Office Account'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.officeData &&
          <SidebarMenuItem
            to='office/data'
            title='Office Account Data'
            path='officedata'
          />
        }
      </SidebarSubItem>

      {/* Smart Meter */}
      <SidebarSubItem
        to='smartdevices'
        title='Smart Devices'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.smartMeter &&
          <SidebarMenuItem
            to='smart-meter'
            title='Smart Meter'
            path='smartmeter'
          />
        }
        {accessObject.smartDoorLocks &&
          <SidebarMenuItem
            to='smart-door-locks'
            title='Smart Door Locks'
            path='smartdoorlocks'
            isComingSoon={(envCheck === 'live' && userSlice?.role !== 'Admin') ? true : false}
          />
        }
        {accessObject.smartLockGateway &&
          <SidebarMenuItem
            to='gateway'
            title='Smart Lock Gateway'
            path='smartlockgateway'
            isComingSoon={(envCheck === 'live' && userSlice?.role !== 'Admin') ? true : false}
          />
        }
      </SidebarSubItem>

      {/* Accounting */}
      <SidebarSubItem
        to='accounting'
        title='Accounting'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.ownerBill &&
          <SidebarMenuItem
            to='accounting/owner-bill'
            title='Invoice'
            path='owner-bill'
          />
        }
        {accessObject.billing &&
          <SidebarMenuItem
            to='accounting/bill'
            title='Billings'
            path='billing'
          />
        }
        {accessObject.receipt &&
          <SidebarMenuItem
            to='accounting/receipt'
            title='Receipts'
            path='receipt'
          />
        }
        {accessObject.depositRefund &&
          <SidebarMenuItem
            to='accounting/deposit-refund'
            title='Deposit Refund'
            path='depsoit-refund'
          />
        }
        {accessObject.expenses &&
          <SidebarMenuItem
            to='accounting/expenses'
            title='Expenses'
            path='expenses'
          />
        }
        {accessObject.paymentVoucher &&
          <SidebarMenuItem
            to='accounting/payment-voucher'
            title='Payment Voucher'
            path='payment-voucher'
          />
        }
        {accessObject.eInvoiceSetUp &&
          <SidebarMenuItem
            to='accounting/e-invoice/setup'
            title='E-Invoice Form Set Up'
            path='eInvoiceSetUp'
          />
        }
        {accessObject.creditNote &&
          <SidebarMenuItem
            to='accounting/creditNote'
            title='Credit Note'
            path='creditNote'
          />
        }
        {accessObject.debitNote &&
          <SidebarMenuItem
            to='accounting/debitNote'
            title='Debit Note'
            path='debitNote'
          />
        }
      </SidebarSubItem>

      {/* Transaction History */}
      {accessObject.paymentTransaction &&
        <SidebarMenuItem
          to='transaction/payment'
          title='Payment Transaction'
          path='paymenttransaction'
        />
      }

      {/* Payout Transaction History */}
      {accessObject.payoutTransaction &&
        <SidebarMenuItem
          to='transaction/payout'
          title='Payout Transaction'
          path='payouttransaction'
        />
      }

      {/* Inventory */}
      <SidebarSubItem
        to='inventory'
        title='Inventory'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.inventoryList &&
          <SidebarMenuItem
            to='inventory/list'
            title='Inventory List'
            path='inventoryList'
          />
        }
        {accessObject.inventoryTransaction &&
          <SidebarMenuItem
            to='inventory/transaction'
            title='Inventory Transaction'
            path='inventoryTransaction'
          />
        }
      </SidebarSubItem>

      {/* Report */}
      <SidebarSubItem
        to='report'
        title='Report'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.payoutReport &&
          <SidebarMenuItem
            to='report/payout-report'
            title='Management Property Payout Report'
            path='payout-report'
          />
        }
      </SidebarSubItem>

      <SidebarSubItem
        to='administration'
        title='Administration'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.userRole &&
          <SidebarMenuItem
            to='administration/user-role'
            title='User Role'
            path='user-role'
          />
        }
        {accessObject.administratorProfile &&
          <SidebarMenuItem
            to='administration/profile'
            title='Administrator Profile'
            path='administrator-profile'
          />
        }
        {accessObject.auditTrails &&
          <SidebarMenuItem
            to='administration/audit-trails'
            title='Audit Trails'
            path='audit-trails'
          />
        }
      </SidebarSubItem>

      <SidebarSubItem
        to='setup'
        title='Setup'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        {accessObject.billType &&
          <SidebarMenuItem
            to='setup/billType'
            title='Bill Type'
            path='billType'
          />
        }
        {accessObject.contractorData &&
          <SidebarMenuItem
            to='setup/contractorData'
            title='Contractor Data'
            path='contractorData'
          />
        }
        {accessObject.expensesType &&
          <SidebarMenuItem
            to='setup/expensesType'
            title='Expenses Type'
            path='expensesType'
          />
        }
        {accessObject.settings &&
          <SidebarMenuItem
            to='setup/settings'
            title='Settings'
            path='Settings'
          />
        }
        {accessObject.announcement &&
          <SidebarMenuItem
            to='setup/announcement'
            title='Announcement'
            path='announcement'
          />
        }
      </SidebarSubItem>

      {accessObject.nextsixListing &&
        <SidebarMenuItem
          to='listing/nextsix-listing'
          title='Nextsix Listing'
          path='nextsixlisting'
        />
      }

      {/* {accessObject.showcaseListing &&
        <SidebarMenuItem
          to='listing/showcase-listing'
          title='NextSix Showcase Listing'
          path='showcaselisting'
        />
      } */}
    </>
  )
}

export { SidebarMenuMain }
